<template>
  <div class="layout__wrapper">
    <section class="billing-details">
      <div class="container">
        <BillingCoupon
          v-if="billing.showDiscountBanner"
          :billing="billing"
          class="billing-notifications__prompt"
        />
        <BillingNotifications :billing="billing" />

        <div class="plan-payment">
          <PlanInfoMonthly
            v-if="billing.plan.id === 'plan_monthly'"
            :billing="billing"
          />
          <PlanInfoAnnual
            v-if="billing.plan.id === 'plan_annual'"
            :billing="billing"
          />
          <PaymentInfo :billing="billing" />
        </div>

        <!--div class="payment-history">
          <h3 class="payment-history__title">Payment History</h3>
          <div class="payment-history__table-box">
            <table class="history-table"></table>
          </div>
        </div>
      </div-->

        <div v-if="billing.cancel_at_period_end" class="billing-cancel">
          <p class="billing-cancel__text">
            Want to reactivate your Shortform subscription?
            <v-wait class="billing-cancel__wait" for="Subscribing">
              <template v-slot:waiting>
                <span class="billing-cancel__link">
                  Processing...
                  <button-spinner />
                </span>
              </template>
              <a
                class="billing-cancel__link"
                href="javascript:void(0);"
                @click="reactivate"
              >
                <span> Click here to resubscribe </span> </a
              >.
            </v-wait>
          </p>
        </div>
        <div v-else class="billing-cancel">
          <p class="billing-cancel__text">
            Want to stop your Shortform subscription?
            <a
              class="billing-cancel__link"
              href="javascript:void(0);"
              @click="cancelClick"
              >Click here to cancel</a
            >.
          </p>
          <CancelFlowPopup ref="cancelFlow" :billing="billing" />
        </div>
      </div>
    </section>
    <InfoQuestions />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import { useWait } from '@/app/composables/useWait'
import type { BillingView } from '@/models/billing'

import BillingCoupon from './BillingCoupon.vue'

import PlanInfoMonthly from './BillingDataPaid.PlanInfo.Monthly.vue'
import PlanInfoAnnual from './BillingDataPaid.PlanInfo.Annual.vue'
import PaymentInfo from './BillingDataPaid.PaymentInfo.vue'
import CancelFlowPopup from './CancelFlowPopup.vue'
import InfoQuestions from './InfoQuestions.vue'

import BillingNotifications from './BillingNotifications.vue'
import { Mixpanel } from '@/analytics/mixpanel'

const props = defineProps<{
  billing: BillingView
}>()

const wait = useWait()
const emit = defineEmits(['subscribed'])

const cancelFlow = ref<InstanceType<typeof CancelFlowPopup> | null>(null)

function cancelClick(): void {
  Mixpanel.trackCancelSubscriptionClick(props.billing)
  cancelFlow.value?.show()
}

async function reactivate(): Promise<void> {
  try {
    wait.start('Subscribing')
    await props.billing.subscribeTo(props.billing.plan)
    emit('subscribed')
    wait.end('Subscribing')
  } catch (error) {
    wait.end('Subscribing')
  }
}
</script>

<style lang="scss" scoped>
.billing-notifications__prompt {
  margin-bottom: 42px;
  padding-inline: 0;
  @media (max-width: $w-medium-s) {
    margin-bottom: 28px;
  }
  @media (max-width: $w-mobile-s) {
    margin-bottom: 12px;
  }
}
</style>
